// src/components/chat/MessageInput.jsx
import React, { useRef } from 'react';
import StickerPicker from '../StickerPicker';
import './MessageInput.css';

const MessageInput = ({
    // Значения
    inputMessage,
    attachments,
    editingMessage,
    replyTo,
    isRecording,
    isUploading,
    recordingTime,
    showStickerPicker,

    // Колбэки
    onInputChange,              // (value) => void
    onSendOrEdit,               // () => void
    onFileSelect,               // (e) => void
    onPaste,                    // (e) => void
    onToggleStickerPicker,      // () => void
    onCloseStickerPicker,       // () => void
    onStickerSelect,            // (sticker) => void
    onStartRecording,           // () => void
    onStopRecording,            // () => void
    onCancelRecording,          // () => void
    onTyping,                   // (text) => void
    onAutoResize,               // (textarea) => void

    // Refs
    textareaRef,
    formatDuration,
}) => {
    const wrapperRef = useRef(null);    

  

    const handleTextareaChange = (e) => {
        const value = e.target.value;
        onInputChange?.(value);
        onTyping?.(value);
        onAutoResize?.();
    };

    const showSendButton = 
        inputMessage.trim() || 
        attachments.length > 0 || 
        editingMessage;

    return (
        <>
            <div className="message-input-wrapper" ref={wrapperRef}>
                {/* Кнопка прикрепления */}
                <label className="attach-btn">
                    <i className="bi bi-paperclip"></i>
                    <input
                        type="file"
                        multiple
                        onChange={onFileSelect}
                        hidden
                        disabled={!!editingMessage}
                    />
                </label>

                {/* Textarea + стикеры */}
                <div className="textarea-wrapper">
                    <textarea
                        name="message-content"
                        ref={textareaRef}
                        value={inputMessage}
                        onChange={handleTextareaChange}
                        
                        onPaste={onPaste}
                        placeholder={
                            isRecording 
                                ? `Запись... ${formatDuration?.(recordingTime) || '0:00'}` 
                                : 'Сообщение...'
                        }
                        disabled={isRecording}
                        rows={1}
                        className="message-textarea"
                    />

                    {/* Кнопка стикеров (при пустом поле) */}
                    {!inputMessage.trim() && !editingMessage && (
                        <div
                            className="sticker-placeholder-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onToggleStickerPicker?.();
                            }}
                        >
                            <i className="bi bi-emoji-smile"></i>
                        </div>
                    )}
                </div>

                {/* Кнопка отправки / редактирования / микрофона */}
                {showSendButton ? (
                    <button
                        className={editingMessage ? 'send-btn edit-btn' : 'send-btn'}
                        onClick={onSendOrEdit}
                        disabled={isUploading}
                        onTouchEnd={(e) => {
                            e.preventDefault();
                            onSendOrEdit?.();
                        }}
                    >
                        {editingMessage ? (
                            <i className="bi bi-pencil-square"></i>
                        ) : isUploading ? (
                            <i className="bi bi-hourglass-split"></i>
                        ) : replyTo ? (
                            <i className="bi bi-reply-fill"></i>
                        ) : (
                            <i className="bi bi-send-fill"></i>
                        )}
                    </button>
                ) : (
                    <button
                        className={isRecording ? 'recording-btn' : 'mic-btn'}
                        onClick={(e) => {
                            e.preventDefault();
                            if (isRecording) {
                                onStopRecording?.();
                            } else {
                                onStartRecording?.();
                            }
                        }}
                    >
                        <i className={isRecording ? 'bi bi-stop-fill' : 'bi bi-mic-fill'}></i>
                    </button>
                )}
            </div>

            {/* Стикеры */}
            {showStickerPicker && (
                <StickerPicker
                    onSelect={onStickerSelect}
                    onClose={onCloseStickerPicker}
                />
            )}

            {/* Статус записи */}
            {isRecording && (
                <div className="recording-status">
                    <span className="recording-dot"></span>
                    <span className="recording-time">
                        {formatDuration?.(recordingTime) || '0:00'}/03:00
                    </span>
                    <span className="recording-divider"></span>
                    <button
                        type="button"
                        className="recording-cancel-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            onCancelRecording?.();
                        }}
                        title="Отменить запись"
                    >
                        <i className="bi bi-trash3"></i>
                    </button>
                </div>
            )}
        </>
    );
};

export default MessageInput;